import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  accent?: boolean;
}

export function Card({ children, className = '', padding = 'md', accent = false }: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={`bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300 ${paddingStyles[padding]} ${className}`}
      style={accent ? { borderTop: '3px solid #E05A1C' } : {}}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}

export function CardHeader({ title, subtitle, action, icon }: CardHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #1B2B6B, #5B8DB8)' }}>
            <span className="text-white">{icon}</span>
          </div>
        )}
        <div>
          <h3 className="text-lg font-semibold" style={{ color: '#1B2B6B' }}>{title}</h3>
          {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        </div>
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
